module.exports = __webpack_public_path__ + "static/new_filters_art-5e534244b661684f153ed6f55ab4a667.png";